// The social card: where it is, how big it is, and what it says.
//
// Declared here rather than typed into the head component, because two other
// things need the same three facts — the build check that asserts every page
// names a card, and the test that asserts the file the tag points at is the
// one the repository actually ships.
//
// The dimensions are published in `og:image:width` and `og:image:height` so a
// preview can reserve the space before the image has arrived. They must match
// the file: apps/web/scripts/render-og-card.mjs rasterises the card and
// refuses to write a PNG of any other size.

/** The card's address on this origin. */
export const OG_CARD = "/og-card.png";

/** The size every network crops a large card to. */
export const OG_CARD_WIDTH = 1200;
export const OG_CARD_HEIGHT = 630;

/** What the card says, for a reader who is given the text instead of the picture. */
export const OG_CARD_ALT =
  "doc.cheap – passport and ID OCR API. One HTTP call. Free – 100 documents every month, then 1¢ per document.";
